module.exports = __webpack_public_path__ + "img/logo.f32f9783.png";